export function setSessionStorage(key: string, value: any): void {
    const str = window.JSON.stringify(value);
    window.sessionStorage.setItem(key, str);
}

export function getSessionStorage(key: string): any {
    let json: string | null;
    json = window.sessionStorage.getItem(key);
    if (json) json = window.JSON.parse(json);
    return json;
}

export function setLocalStorage(key: string, value: any): void {
    const str = window.JSON.stringify(value);
    window.localStorage.setItem(key, str);
}

export function getLocalStorage(key: string): any {
    let json: string | null;
    json = window.localStorage.getItem(key);
    if (json) json = window.JSON.parse(json);
    return json;
}


export function removeLocalStorage(key: string): void {
    window.localStorage.removeItem(key);
}


export function removeAllLocalStorage(): void {
    window.localStorage.clear();
}

export function loginOutDataClear(): void {
    removeLocalStorage('refresh_token');
    removeLocalStorage('access_token');
    removeLocalStorage('user');
    removeLocalStorage('accountid');
    removeLocalStorage('collegeDetail');
    removeLocalStorage('background');

}


